import script from "./DebugSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugSection.vue?vue&type=script&setup=true&lang=js"

import "./DebugSection.vue?vue&type=style&index=0&id=0371098e&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0371098e"]])

export default __exports__